import React, {useState} from 'react';
import {bbFindCustomerTagsById, bbFindUserTagsByTagId, isCurrentUserMemberOf} from "../../../util/bbHelpers";
import {useSelector} from "react-redux";
import {Chip, } from "@mui/material";
import {BRCustomizedTooltip as Tooltip} from "../../customBreachBits/accents/BRCustomizedTooltip";
// import {Link} from "react-router-dom"
import {HashLink as Link} from "react-router-hash-link";
import BBIconEarlylAccessExclusiveTicket from "../../../assets/bbCustomIcons/BBIconEarlyAccessExclusiveTicket";
import BBIconEarlyAccessExclusiveTicket from "../../../assets/bbCustomIcons/BBIconEarlyAccessExclusiveTicket";


export const EarlyAccessChip = (props)=> {
        return <div className={"m-1"}>
            <Tooltip title={"This is an Early Access feature."}>
                        <span>
                            <Chip
                                icon={<BBIconEarlyAccessExclusiveTicket/>}
                                size={"small"}
                                label={"Early Access"}
                                color={"secondary"}
                                clickable
                                // href={"/board/faq/EarlyAccessProgram"}
                                component={Link}
                                to={"/board/faq/EarlyAccessProgram"}
                            />
                        </span>
            </Tooltip>
        </div>
    }


const EarlyAccessWrapper = (props)=>{
    // const blankChild =
    // const {} = props ? props : {children: undefined};
    const {
        children = <></>,
            hideVisibleWrapper = false

    } = props ? props : {children: undefined, hideVisibleWrapper: false};

    const {customers, customerInView, loadingTargets, loadingHumans} = useSelector(({customer}) => customer);
    const authUser = useSelector(({auth}) => auth.authUser);
    const customer = customers ? customerInView ? customers[customerInView] : null : null;

    const isStaffAdmin = isCurrentUserMemberOf(authUser, "admin") || isCurrentUserMemberOf(authUser, "staff");

    const earlyAccessTagsUser = bbFindUserTagsByTagId(authUser, 53);
    const userHasEarlyAccess = earlyAccessTagsUser && earlyAccessTagsUser.length > 0;

    const earlyAccessTagsCustomer = bbFindCustomerTagsById(customer, 54);
    const customerHasEarlyAccess = earlyAccessTagsCustomer && earlyAccessTagsCustomer.length > 0;

    if(userHasEarlyAccess || customerHasEarlyAccess || isStaffAdmin){
        if(hideVisibleWrapper){
            return children
        }else {
            return <>

                <div className={"m-1 p-2 pt-3"} style={{border:"solid #9c27b0 1px", borderRadius: '5px', backgroundColor: 'rgba(156, 39, 176, 0.05)', }}>
                    <div style={{marginTop: -33, marginRight: -5, float: "right"}}><EarlyAccessChip/></div>
                    {children}

                </div>
            </>
        }



    } else{
        return null;
            // <Widget styleName={"p-2"}>
            //     <div className={"m-2 p-3"}>
            //         <Row>
            //             <ComingSoonIconSettings/>
            //         </Row>
            //     </div>
            // </Widget>

    }
}


export default EarlyAccessWrapper;